import * as Web3Utils from 'web3-utils';

const pdfMake = require('pdfmake/build/pdfmake.js');
const pdfFonts = require('pdfmake/build/vfs_fonts.js');
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default function transactionPdfMaker(row, getMember, owners) {
  const rowsTop: any[] = [];
  const rows: any[] = [];
  const p = 'Transaction of ' + row.amount + ' on ' + row.date;
  const title = 'Transaction ' + (row.direction === 'OUT' ? 'to ' : 'from ') + row.address;
  const gasFee = 'gasPrice' in row.tx ? 'Gas Price: ' + Web3Utils.fromWei(row.tx.gasPrice) : '';
  function ownerSign(name) {
    return { text: '\nSignature: ' + name, alignment: 'right', italics: true };
  }
  for (let addr in owners) {
    const sign3Row = [
      {},
      { text: '\nDirector: ' + getMember(addr).name, alignment: 'right' },
      { text: '', alignment: 'left' },
      ownerSign(getMember(addr).name)
    ];
    rows.push(sign3Row);
  }
  const dd = {
    content: [
      {
        text: title,
        style: 'header',
        margin: [0, 0, 0, 5],
        fontSize: 22
      },
      {
        text: p,
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 5]
      },
      {
        text: gasFee,
        style: 'header',
        bold: false,
        margin: [0, 0, 0, 5]
      },
      {
        table: {
          widths: ['*', 'auto', '20%', 'auto'],
          body: rows,
          headerRows: 0
        },
        layout: 'noBorders',
        style: 'header',
        bold: false,
        margin: [0, 150, 0, 0]
      }
    ],
    styles: {
      header: {
        fontSize: 18,
        bold: true,
        alignment: 'left'
      }
    }
  };
  return pdfMake.createPdf(dd);
}
